import { graphql } from '../../gql';

export const MonthWeekIndexQuery = graphql(`
  query MonthWeekIndexQuery {
    index {
      startMonth
      startMonthIndex
      endMonthIndex
      startWeek
      startWeekIndex
      endWeekIndex
      maxWeekIndex
      endMonth
      maxWeek
    }
  }
`);
